import React, { useEffect, useReducer } from 'react'
import {
  countToStr,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../../tools/util'
import {
  GET_ORDER_PAGE,
  GET_ORDER_STATE_COUNT,
  BATCH_DOWNLOAD_ZIP_THE_CONTRACT,
  ExportZipParams,
  OrderPageParam,
  OrderPageRes,
} from '../../../api/orderManage'
import { ORDER_EXPORT_ORDER_DETAIL } from '../../../api/downfileapi'
import { message } from 'antd'
import { useQuery } from '../../../tools/utilHooks'
import { paymentStatusDictInvert } from '../../../tools/state'
import _ from 'lodash'
import { history } from '../../../redux/store'
import moment from 'moment'

export const orderassuranceTabKeyList = [
  '待履约',
  '履约中',
  '待验收',
  '订单超期',
  '已完成',
  '全部',
] as const
export type orderassuranceTabKey = (typeof orderassuranceTabKeyList)[number]
// | '待履约'
// | '履约中'
// | '待验收'
// | '已完成'
// | '全部'
type RadioDict = {
  [x in orderassuranceTabKey]: {
    key: string
    keyName: string
    value: string
    numMap: string
  }
}
interface paginationOption {
  total: number
  current: number
  pagesize: number
}
interface orderCountsState {
  acceptedCount: number // 待验收订单个数
  processCount: number // 履约中订单个数
  waitCount: number // 待履约订单个数
  overdueCount: number // 订单超期订单个数
  completeCount: number // 已完成订单个数
}

interface CheckGroupParam {
  salesReturnState?: boolean
  cancelState?: boolean
}
const initialCheckGroupParam: CheckGroupParam = {
  salesReturnState: false,
}
interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderassuranceTabKey // 当前选中tab的key值
  dataSource: OrderPageRes[]
  isTableLoading?: boolean
  orderCountsState: orderCountsState
  pagination: paginationOption
  searchParam: any
  selectedRows: any[]
  checkGorupParam: CheckGroupParam
}

type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPagination'
  | 'setOrderCountsState'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setSelectedRows'
  | 'setCheckGroupParamAction'
interface Action {
  type: ActionType
  payload: any
}

/** 订单页签「订单超期」对应 orderPageState */
const ORDER_OVERDUE_TAB_NUM_MAP = '5'
/** 订单超期 tab 下列表默认订单超期：发货超期、妥投超期 */
const TAB_DEFAULT_OVERDUE_TYPE = '1,2'

/**
 * 列表/导出等入参：
 * - 搜索入参里若包含 overdueType 键：非空则用其值；清空（空串）则不带超期条件；
 * - 若未包含该键且在订单超期 tab（numMap 5）：用 tab 默认 "1,2"。
 */
function resolveOrderListOverdueType(
  searchOverdueType: unknown,
  isOverdueTab: boolean,
  overdueTypeKeyProvided: boolean,
): string | undefined {
  if (overdueTypeKeyProvided) {
    if (String(searchOverdueType ?? '').trim() === '') {
      return undefined
    }
    return String(searchOverdueType)
  }
  if (isOverdueTab) {
    return TAB_DEFAULT_OVERDUE_TYPE
  }
  return undefined
}

const initialRadioDict: RadioDict = {
  待履约: {
    key: 'toAssure',
    value: '待履约(0)',
    keyName: '待履约',
    numMap: '1',
  },
  履约中: {
    key: 'ausuring',
    value: '履约中(0)',
    keyName: '履约中',
    numMap: '2',
  },
  待验收: {
    key: 'toCheck',
    value: '待验收(0)',
    keyName: '待验收',
    numMap: '3',
  },
  订单超期: {
    key: 'overdue',
    value: '订单超期(0)',
    keyName: '订单超期',
    numMap: '5',
  },
  已完成: {
    key: 'finished',
    value: '已完成',
    keyName: '已完成',
    numMap: '4',
  },
  全部: {
    key: 'all',
    value: '全部',
    keyName: '全部',
    numMap: '',
  },
}
const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '待履约',
  dataSource: [],
  isTableLoading: false,
  orderCountsState: {
    acceptedCount: 0,
    processCount: 0,
    waitCount: 0,
    overdueCount: 0,
    completeCount: 0,
  },
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  checkGorupParam: {},
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setOrderCountsState':
      newstate.orderCountsState = action.payload
      return newstate
    case 'setCurrentRadioDict':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setCheckGroupParamAction':
      newstate.checkGorupParam = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

const setCheckGroupParamAction = (val: CheckGroupParam): Action => ({
  type: 'setCheckGroupParamAction',
  payload: val,
})
/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})
/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
const setDataSource = (val: OrderPageRes[]): Action => ({
  type: 'setDataSource',
  payload: val,
})
/**
 * 设置订单数据相关
 * @param val
 * @returns
 */
const setOrderCountsState = (val: orderCountsState): Action => ({
  type: 'setOrderCountsState',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
/**
 * @param val
 * @returns
 */
const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

const dateFormat = 'YYYY-MM-DD HH:mm:ss'
export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const query = useQuery()
  const tab = query.get('tab') || ''
  const overdueTypeFromUrl = (query.get('overdueType') || '').trim()
  const orderStateParam = query.get('orderState') || ''
  const accountOpenInvoiceStatusParam =
    query.get('accountOpenInvoiceStatus') || ''
  const positiveActualAmountOnly = query.get('positiveActualAmountOnly') === 'true'
  const paymentStatusParam = query.get('paymentStatus') || ''
  const {
    checkedRadioKey,
    currentRadioDict,
    checkGorupParam,
    orderCountsState,
    pagination,
    searchParam,
    selectedRows,
  } = state

  function getHasFilterBtn(currentKey: orderassuranceTabKey) {
    return _.chain(orderassuranceTabKeyList)
      .pullAll(['待履约', '待验收', '履约中'])
      .value()
      .includes(currentKey)
  }

  const handleCheckedChange = (key: orderassuranceTabKey) => {
    dispatch(setCheckedRadioKey(key))
    dispatch(
      setSearchParam({ orderPageState: currentRadioDict?.[key]?.numMap ?? '' }),
    )

    handleOrderListRequest({
      ...searchParam,
      ...(getHasFilterBtn(key) ? checkGorupParam : initialCheckGroupParam),
      orderPageState: currentRadioDict?.[key]?.numMap ?? '',
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }

  const handleSearchClick = (value: any) => {
    const next = { ...searchParam, ...value }
    dispatch(setSearchParam(next))
    handleOrderListRequest({
      ...next,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    handleOrderListRequest({
      ...searchParam,
      pageNo: page,
      pageSize: pageSize ?? pagination.pagesize,
    })
  }

  const getOrderCountsState = async () => {
    const res = await GET_ORDER_STATE_COUNT({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setOrderCountsState({ ...res.data }))

      let finalTab: orderassuranceTabKey = '全部'
      if (tab === 'total' || tab === 'waitship') {
        if (tab === 'total') {
          if (res.data.waitCount > 0) {
            finalTab = '待履约'
          } else if (res.data.processCount > 0) {
            finalTab = '履约中'
          } else if (res.data.acceptedCount > 0) {
            finalTab = '待验收'
          }
        }
        if (tab === 'waitship') {
          if (res.data.waitCount > 0) {
            finalTab = '待履约'
          } else if (res.data.processCount > 0) {
            finalTab = '履约中'
          }
        }
        const numMap = currentRadioDict[finalTab]?.numMap ?? ''
        dispatch(setCheckedRadioKey(finalTab))
        dispatch(setSearchParam({ orderPageState: numMap }))
        handleOrderListRequest({
          ...initialCheckGroupParam,
          pageNo: 1,
          orderPageState: numMap,
          pageSize: pagination.pagesize,
        })
        return
      }

      // 从侧边栏进入订单履约页面 判断当前待履约订单数量
      // 待履约订单数为0时 默认选中全部tab
      if (res.data.waitCount === 0 && !tab) {
        dispatch(setCheckedRadioKey('全部'))
        dispatch(setSearchParam({ orderPageState: '' }))
        handleOrderListRequest({
          ...initialCheckGroupParam,
          pageNo: 1,
          orderPageState: '',
          pageSize: pagination.pagesize,
        })
      }
    } else {
      message.warning(res.msg)
    }
  }
  const convertTableState = (list: any[]) => {
    return list.map((item) => {
      return {
        ...item,
        paymentStatus: paymentStatusDictInvert?.[item.paymentStatus]?.name,
      }
    })
  }

  const handleOrderListRequest = async (param: OrderPageParam) => {
    dispatch(setIsTableLoading(true))
    const currentCheckGroupParam = {
      salesReturnState: param.salesReturnState ? true : false,
      cancelState: param.cancelState ? true : false,
    }

    const merged: OrderPageParam = {
      ...currentCheckGroupParam,
      orderPageState: currentRadioDict[checkedRadioKey].numMap,
      pageNo: pagination.current,
      pageSize: pagination.pagesize,
      ...param,
    }
    const rawOrderPageState = String(merged.orderPageState ?? '')
    const isOverdueTab = rawOrderPageState === ORDER_OVERDUE_TAB_NUM_MAP
    const resolvedOverdueType = resolveOrderListOverdueType(
      merged.overdueType,
      isOverdueTab,
      typeof param === 'object' && param !== null && 'overdueType' in param,
    )
    if (resolvedOverdueType !== undefined) {
      merged.overdueType = resolvedOverdueType
    } else {
      delete merged.overdueType
    }
    if (isOverdueTab) {
      merged.orderPageState = ''
    }

    const res = await GET_ORDER_PAGE(merged)
    if (isResponseCodeSuccess(res.code)) {
      const data = res.data.content.map((item: any) => ({
        ...item,
        arrivalTime: !item.arrivalTime
          ? item.arrivalTime
          : moment(Number(item.arrivalTime)).format(dateFormat),
        writeOffTime: !item.writeOffTime
          ? item.writeOffTime
          : moment(Number(item.writeOffTime)).format(dateFormat),
      }))
      // 设置当前表格数据
      dispatch(setDataSource(convertTableState(data)))
      // 设置当前页面数据量
      dispatch(
        setPagination({
          ...pagination,
          pagesize: res.data.pageSize,
          current: res.data.pageNo,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
      dispatch(
        setCheckGroupParamAction({
          ...currentCheckGroupParam,
        }),
      )
    } else {
      message.warning(res.msg)
    }
  }
  const handleTableRefresh = async () => {
    handleOrderListRequest({
      ...initialCheckGroupParam,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }
  // 首次加载页面时，获取订单数量
  useEffect(() => {
    let searchParam: any = {}

    // 需求参考：https://alidocs.dingtalk.com/i/nodes/kDnRL6jAJMDPNwwpu3RLjOONVyMoPYe1?utm_scene=team_space&iframeQuery=
    if (tab === 'waitacceptance') {
      searchParam = { orderPageState: '3' }
      dispatch(setCheckedRadioKey('待验收'))
      dispatch(setSearchParam({ orderPageState: '3' }))
      handleOrderListRequest({
        ...searchParam,
        ...initialCheckGroupParam,
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
      getOrderCountsState()
    } else if (tab === 'waitship') {
      // 待发货：先获取订单数量，然后在getOrderCountsState中根据数量决定tab
      getOrderCountsState()
    } else if (tab === 'all') {
      // 全部tab，设置筛选条件
      dispatch(setCheckedRadioKey('全部'))
      searchParam = { orderPageState: '' }

      // 处理订单状态筛选
      if (orderStateParam) {
        // 订单状态：已完成 -> orderPageState: '4'
        if (orderStateParam === '已完成') {
          searchParam.orderPageState = '4'
        }
      }

      if (positiveActualAmountOnly) {
        searchParam.positiveActualAmountOnly = true
      }

      // 处理供应商开票状态筛选
      if (accountOpenInvoiceStatusParam) {
        // 供应商开票状态：未开票 -> accountOpenInvoiceStatus: '5'
        if (accountOpenInvoiceStatusParam === '未开票') {
          searchParam.accountOpenInvoiceStatus = '5'
        }
      }

      // 处理付款状态筛选
      if (paymentStatusParam) {
        // 付款状态：待申请 -> paymentStatus: '2'
        if (paymentStatusParam === '待申请') {
          searchParam.paymentStatus = '2'
        }
      }

      dispatch(setSearchParam(searchParam))
      handleOrderListRequest({
        ...searchParam,
        ...initialCheckGroupParam,
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
      getOrderCountsState()
    } else if (tab === 'overdue') {
      const overdueTypeResolved =
        overdueTypeFromUrl === '1' || overdueTypeFromUrl === '2'
          ? overdueTypeFromUrl
          : TAB_DEFAULT_OVERDUE_TYPE
      dispatch(setCheckedRadioKey('订单超期'))
      const searchParamOverdue: Record<string, string> = {
        orderPageState: ORDER_OVERDUE_TAB_NUM_MAP,
        overdueType: overdueTypeResolved,
      }
      dispatch(setSearchParam(searchParamOverdue))
      handleOrderListRequest({
        ...searchParamOverdue,
        ...initialCheckGroupParam,
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
      getOrderCountsState()
    } else {
      handleOrderListRequest({
        ...searchParam,
        ...initialCheckGroupParam,
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
      // 默认情况
      getOrderCountsState()
    }
    // eslint-disable-next-line
  }, [])
  const handleCheckParamChange = async (value: CheckGroupParam) => {
    const newCheckParam = {
      ...checkGorupParam,
      ...value,
    }
    dispatch(setCheckGroupParamAction(newCheckParam))
    handleOrderListRequest({
      ...searchParam,
      ...newCheckParam,
    })
  }
  // orderCountsState 发生变化的时候，带动tab数据变化。
  useEffect(() => {
    const newRadioDict = { ...currentRadioDict }
    newRadioDict['待履约'].value = `待履约(${countToStr(
      orderCountsState.waitCount,
    )})`
    newRadioDict['履约中'].value = `履约中(${countToStr(
      orderCountsState.processCount,
    )})`
    newRadioDict['待验收'].value = `待验收(${countToStr(
      orderCountsState.acceptedCount,
    )})`
    newRadioDict['订单超期'].value = `订单超期(${countToStr(
      orderCountsState.overdueCount,
    )})`
    newRadioDict['已完成'].value = `已完成(${countToStr(
      orderCountsState.completeCount,
    )})`
    dispatch(setCurrentRadioDict(newRadioDict))

    // eslint-disable-next-line
  }, [orderCountsState])
  const handleTableChangeCheck = (selectedRowKeys: any) => {
    dispatch(setSelectedRows(selectedRowKeys))
  }
  const exportFile = async () => {
    if (selectedRows.length < 1) {
      message.warning('请勾选导出数据')
      return
    }
    await ORDER_EXPORT_ORDER_DETAIL({ ids: selectedRows })
  }

  const batchDownloadContractFile = async () => {
    const rawOrderPageState = String(
      searchParam?.orderPageState ??
        currentRadioDict[checkedRadioKey]?.numMap ??
        '',
    )
    const isOverdueTab = rawOrderPageState === ORDER_OVERDUE_TAB_NUM_MAP
    const resolvedOverdueType = resolveOrderListOverdueType(
      searchParam?.overdueType,
      isOverdueTab,
      searchParam != null &&
        typeof searchParam === 'object' &&
        'overdueType' in searchParam,
    )
    const params: ExportZipParams = {
      ids: selectedRows,
      ...searchParam,
      supplierId: getSupplierId(),
    }
    if (isOverdueTab) {
      params.orderPageState = ''
    }
    if (resolvedOverdueType !== undefined) {
      params.overdueType = resolvedOverdueType
    } else {
      delete params.overdueType
    }
    const res = await BATCH_DOWNLOAD_ZIP_THE_CONTRACT(params)
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    } else {
      message.warning(res.msg)
    }
  }

  // 跳转至客户回款明细页面
  const jumpToPaymentDetails = () => {
    history.push({
      pathname: '/srm/paymentDetails',
    })
  }

  return {
    state,
    getHasFilterBtn,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    handleTableChangeCheck,
    exportFile,
    batchDownloadContractFile,
    handleCheckParamChange,
    jumpToPaymentDetails,
  }
}
import React, { useEffect, useReducer } from 'react'
import {
  countToStr,
  getSupplierId,
  isResponseCodeSuccess,
} from '../../../tools/util'
import {
  GET_ORDER_PAGE,
  GET_ORDER_STATE_COUNT,
  BATCH_DOWNLOAD_ZIP_THE_CONTRACT,
  ExportZipParams,
  OrderPageParam,
  OrderPageRes,
} from '../../../api/orderManage'
import { ORDER_EXPORT_ORDER_DETAIL } from '../../../api/downfileapi'
import { message } from 'antd'
import { useQuery } from '../../../tools/utilHooks'
import { paymentStatusDictInvert } from '../../../tools/state'
import _ from 'lodash'
import { history } from '../../../redux/store'
import moment from 'moment'

export const orderassuranceTabKeyList = [
  '待履约',
  '履约中',
  '待验收',
  '订单超期',
  '已完成',
  '全部',
] as const
export type orderassuranceTabKey = (typeof orderassuranceTabKeyList)[number]
// | '待履约'
// | '履约中'
// | '待验收'
// | '已完成'
// | '全部'
type RadioDict = {
  [x in orderassuranceTabKey]: {
    key: string
    keyName: string
    value: string
    numMap: string
  }
}
interface paginationOption {
  total: number
  current: number
  pagesize: number
}
interface orderCountsState {
  acceptedCount: number // 待验收订单个数
  processCount: number // 履约中订单个数
  waitCount: number // 待履约订单个数
  overdueCount: number // 订单超期订单个数
  completeCount: number // 已完成订单个数
}

interface CheckGroupParam {
  salesReturnState?: boolean
  cancelState?: boolean
}
const initialCheckGroupParam: CheckGroupParam = {
  salesReturnState: false,
}
interface State {
  currentRadioDict: RadioDict // 当前tab列表的值
  checkedRadioKey: orderassuranceTabKey // 当前选中tab的key值
  dataSource: OrderPageRes[]
  isTableLoading?: boolean
  orderCountsState: orderCountsState
  pagination: paginationOption
  searchParam: any
  selectedRows: any[]
  checkGorupParam: CheckGroupParam
}

type ActionType =
  | 'setCurrentRadioDict'
  | 'setCheckedRadioKey'
  | 'setPagination'
  | 'setOrderCountsState'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setSelectedRows'
  | 'setCheckGroupParamAction'
interface Action {
  type: ActionType
  payload: any
}

/** 订单页签「订单超期」对应 orderPageState */
const ORDER_OVERDUE_TAB_NUM_MAP = '5'
/** 订单超期 tab 下列表默认订单超期：发货超期、妥投超期 */
const TAB_DEFAULT_OVERDUE_TYPE = '1,2'

/**
 * 列表/导出等入参：
 * - 搜索入参里若包含 overdueType 键：非空则用其值；清空（空串）则不带超期条件；
 * - 若未包含该键且在订单超期 tab（numMap 5）：用 tab 默认 "1,2"。
 */
function resolveOrderListOverdueType(
  searchOverdueType: unknown,
  isOverdueTab: boolean,
  overdueTypeKeyProvided: boolean,
): string | undefined {
  if (overdueTypeKeyProvided) {
    if (String(searchOverdueType ?? '').trim() === '') {
      return undefined
    }
    return String(searchOverdueType)
  }
  if (isOverdueTab) {
    return TAB_DEFAULT_OVERDUE_TYPE
  }
  return undefined
}

const initialRadioDict: RadioDict = {
  待履约: {
    key: 'toAssure',
    value: '待履约(0)',
    keyName: '待履约',
    numMap: '1',
  },
  履约中: {
    key: 'ausuring',
    value: '履约中(0)',
    keyName: '履约中',
    numMap: '2',
  },
  待验收: {
    key: 'toCheck',
    value: '待验收(0)',
    keyName: '待验收',
    numMap: '3',
  },
  订单超期: {
    key: 'overdue',
    value: '订单超期(0)',
    keyName: '订单超期',
    numMap: '5',
  },
  已完成: {
    key: 'finished',
    value: '已完成',
    keyName: '已完成',
    numMap: '4',
  },
  全部: {
    key: 'all',
    value: '全部',
    keyName: '全部',
    numMap: '',
  },
}
const initialState: State = {
  currentRadioDict: initialRadioDict,
  checkedRadioKey: '待履约',
  dataSource: [],
  isTableLoading: false,
  orderCountsState: {
    acceptedCount: 0,
    processCount: 0,
    waitCount: 0,
    overdueCount: 0,
    completeCount: 0,
  },
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  checkGorupParam: {},
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setOrderCountsState':
      newstate.orderCountsState = action.payload
      return newstate
    case 'setCurrentRadioDict':
      newstate.currentRadioDict = action.payload
      return newstate
    case 'setDataSource':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRows':
      newstate.selectedRows = action.payload
      return newstate
    case 'setCheckGroupParamAction':
      newstate.checkGorupParam = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

const setCheckGroupParamAction = (val: CheckGroupParam): Action => ({
  type: 'setCheckGroupParamAction',
  payload: val,
})
/**
 * 设置当前tab选项列表
 * @param key
 * @returns
 */
const setCurrentRadioDict = (val: any): Action => ({
  type: 'setCurrentRadioDict',
  payload: val,
})
/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})
/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
const setDataSource = (val: OrderPageRes[]): Action => ({
  type: 'setDataSource',
  payload: val,
})
/**
 * 设置订单数据相关
 * @param val
 * @returns
 */
const setOrderCountsState = (val: orderCountsState): Action => ({
  type: 'setOrderCountsState',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})
/**
 * @param val
 * @returns
 */
const setSelectedRows = (val: any): Action => ({
  type: 'setSelectedRows',
  payload: val,
})

const dateFormat = 'YYYY-MM-DD HH:mm:ss'
export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const query = useQuery()
  const tab = query.get('tab') || ''
  const overdueTypeFromUrl = (query.get('overdueType') || '').trim()
  const orderStateParam = query.get('orderState') || ''
  const accountOpenInvoiceStatusParam =
    query.get('accountOpenInvoiceStatus') || ''
  const positiveActualAmountOnly = query.get('positiveActualAmountOnly') === 'true'
  const paymentStatusParam = query.get('paymentStatus') || ''
  const {
    checkedRadioKey,
    currentRadioDict,
    checkGorupParam,
    orderCountsState,
    pagination,
    searchParam,
    selectedRows,
  } = state

  function getHasFilterBtn(currentKey: orderassuranceTabKey) {
    return _.chain(orderassuranceTabKeyList)
      .pullAll(['待履约', '待验收', '履约中'])
      .value()
      .includes(currentKey)
  }

  const handleCheckedChange = (key: orderassuranceTabKey) => {
    dispatch(setCheckedRadioKey(key))
    dispatch(
      setSearchParam({ orderPageState: currentRadioDict?.[key]?.numMap ?? '' }),
    )

    handleOrderListRequest({
      ...searchParam,
      ...(getHasFilterBtn(key) ? checkGorupParam : initialCheckGroupParam),
      orderPageState: currentRadioDict?.[key]?.numMap ?? '',
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }

  const handleSearchClick = (value: any) => {
    const next = { ...searchParam, ...value }
    dispatch(setSearchParam(next))
    handleOrderListRequest({
      ...next,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    handleOrderListRequest({
      ...searchParam,
      pageNo: page,
      pageSize: pageSize ?? pagination.pagesize,
    })
  }

  const getOrderCountsState = async () => {
    const res = await GET_ORDER_STATE_COUNT({
      supplierId: getSupplierId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setOrderCountsState({ ...res.data }))

      let finalTab: orderassuranceTabKey = '全部'
      if (tab === 'total' || tab === 'waitship') {
        if (tab === 'total') {
          if (res.data.waitCount > 0) {
            finalTab = '待履约'
          } else if (res.data.processCount > 0) {
            finalTab = '履约中'
          } else if (res.data.acceptedCount > 0) {
            finalTab = '待验收'
          }
        }
        if (tab === 'waitship') {
          if (res.data.waitCount > 0) {
            finalTab = '待履约'
          } else if (res.data.processCount > 0) {
            finalTab = '履约中'
          }
        }
        const numMap = currentRadioDict[finalTab]?.numMap ?? ''
        dispatch(setCheckedRadioKey(finalTab))
        dispatch(setSearchParam({ orderPageState: numMap }))
        handleOrderListRequest({
          ...initialCheckGroupParam,
          pageNo: 1,
          orderPageState: numMap,
          pageSize: pagination.pagesize,
        })
        return
      }

      // 从侧边栏进入订单履约页面 判断当前待履约订单数量
      // 待履约订单数为0时 默认选中全部tab
      if (res.data.waitCount === 0 && !tab) {
        dispatch(setCheckedRadioKey('全部'))
        dispatch(setSearchParam({ orderPageState: '' }))
        handleOrderListRequest({
          ...initialCheckGroupParam,
          pageNo: 1,
          orderPageState: '',
          pageSize: pagination.pagesize,
        })
      }
    } else {
      message.warning(res.msg)
    }
  }
  const convertTableState = (list: any[]) => {
    return list.map((item) => {
      return {
        ...item,
        paymentStatus: paymentStatusDictInvert?.[item.paymentStatus]?.name,
      }
    })
  }

  const handleOrderListRequest = async (param: OrderPageParam) => {
    dispatch(setIsTableLoading(true))
    const currentCheckGroupParam = {
      salesReturnState: param.salesReturnState ? true : false,
      cancelState: param.cancelState ? true : false,
    }

    const merged: OrderPageParam = {
      ...currentCheckGroupParam,
      orderPageState: currentRadioDict[checkedRadioKey].numMap,
      pageNo: pagination.current,
      pageSize: pagination.pagesize,
      ...param,
    }
    const rawOrderPageState = String(merged.orderPageState ?? '')
    const isOverdueTab = rawOrderPageState === ORDER_OVERDUE_TAB_NUM_MAP
    const resolvedOverdueType = resolveOrderListOverdueType(
      merged.overdueType,
      isOverdueTab,
      typeof param === 'object' && param !== null && 'overdueType' in param,
    )
    if (resolvedOverdueType !== undefined) {
      merged.overdueType = resolvedOverdueType
    } else {
      delete merged.overdueType
    }
    if (isOverdueTab) {
      merged.orderPageState = ''
    }

    const res = await GET_ORDER_PAGE(merged)
    if (isResponseCodeSuccess(res.code)) {
      const data = res.data.content.map((item: any) => ({
        ...item,
        arrivalTime: !item.arrivalTime
          ? item.arrivalTime
          : moment(Number(item.arrivalTime)).format(dateFormat),
        writeOffTime: !item.writeOffTime
          ? item.writeOffTime
          : moment(Number(item.writeOffTime)).format(dateFormat),
      }))
      // 设置当前表格数据
      dispatch(setDataSource(convertTableState(data)))
      // 设置当前页面数据量
      dispatch(
        setPagination({
          ...pagination,
          pagesize: res.data.pageSize,
          current: res.data.pageNo,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
      dispatch(
        setCheckGroupParamAction({
          ...currentCheckGroupParam,
        }),
      )
    } else {
      message.warning(res.msg)
    }
  }
  const handleTableRefresh = async () => {
    handleOrderListRequest({
      ...initialCheckGroupParam,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }
  // 首次加载页面时，获取订单数量
  useEffect(() => {
    let searchParam: any = {}

    // 需求参考：https://alidocs.dingtalk.com/i/nodes/kDnRL6jAJMDPNwwpu3RLjOONVyMoPYe1?utm_scene=team_space&iframeQuery=
    if (tab === 'waitacceptance') {
      searchParam = { orderPageState: '3' }
      dispatch(setCheckedRadioKey('待验收'))
      dispatch(setSearchParam({ orderPageState: '3' }))
      handleOrderListRequest({
        ...searchParam,
        ...initialCheckGroupParam,
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
      getOrderCountsState()
    } else if (tab === 'waitship') {
      // 待发货：先获取订单数量，然后在getOrderCountsState中根据数量决定tab
      getOrderCountsState()
    } else if (tab === 'all') {
      // 全部tab，设置筛选条件
      dispatch(setCheckedRadioKey('全部'))
      searchParam = { orderPageState: '' }

      // 处理订单状态筛选
      if (orderStateParam) {
        // 订单状态：已完成 -> orderPageState: '4'
        if (orderStateParam === '已完成') {
          searchParam.orderPageState = '4'
        }
      }

      if (positiveActualAmountOnly) {
        searchParam.positiveActualAmountOnly = true
      }

      // 处理供应商开票状态筛选
      if (accountOpenInvoiceStatusParam) {
        // 供应商开票状态：未开票 -> accountOpenInvoiceStatus: '5'
        if (accountOpenInvoiceStatusParam === '未开票') {
          searchParam.accountOpenInvoiceStatus = '5'
        }
      }

      // 处理付款状态筛选
      if (paymentStatusParam) {
        // 付款状态：待申请 -> paymentStatus: '2'
        if (paymentStatusParam === '待申请') {
          searchParam.paymentStatus = '2'
        }
      }

      dispatch(setSearchParam(searchParam))
      handleOrderListRequest({
        ...searchParam,
        ...initialCheckGroupParam,
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
      getOrderCountsState()
    } else if (tab === 'overdue') {
      const overdueTypeResolved =
        overdueTypeFromUrl === '1' || overdueTypeFromUrl === '2'
          ? overdueTypeFromUrl
          : TAB_DEFAULT_OVERDUE_TYPE
      dispatch(setCheckedRadioKey('订单超期'))
      const searchParamOverdue: Record<string, string> = {
        orderPageState: ORDER_OVERDUE_TAB_NUM_MAP,
        overdueType: overdueTypeResolved,
      }
      dispatch(setSearchParam(searchParamOverdue))
      handleOrderListRequest({
        ...searchParamOverdue,
        ...initialCheckGroupParam,
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
      getOrderCountsState()
    } else {
      handleOrderListRequest({
        ...searchParam,
        ...initialCheckGroupParam,
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
      // 默认情况
      getOrderCountsState()
    }
    // eslint-disable-next-line
  }, [])
  const handleCheckParamChange = async (value: CheckGroupParam) => {
    const newCheckParam = {
      ...checkGorupParam,
      ...value,
    }
    dispatch(setCheckGroupParamAction(newCheckParam))
    handleOrderListRequest({
      ...searchParam,
      ...newCheckParam,
    })
  }
  // orderCountsState 发生变化的时候，带动tab数据变化。
  useEffect(() => {
    const newRadioDict = { ...currentRadioDict }
    newRadioDict['待履约'].value = `待履约(${countToStr(
      orderCountsState.waitCount,
    )})`
    newRadioDict['履约中'].value = `履约中(${countToStr(
      orderCountsState.processCount,
    )})`
    newRadioDict['待验收'].value = `待验收(${countToStr(
      orderCountsState.acceptedCount,
    )})`
    newRadioDict['订单超期'].value = `订单超期(${countToStr(
      orderCountsState.overdueCount,
    )})`
    newRadioDict['已完成'].value = `已完成(${countToStr(
      orderCountsState.completeCount,
    )})`
    dispatch(setCurrentRadioDict(newRadioDict))

    // eslint-disable-next-line
  }, [orderCountsState])
  const handleTableChangeCheck = (selectedRowKeys: any) => {
    dispatch(setSelectedRows(selectedRowKeys))
  }
  const exportFile = async () => {
    if (selectedRows.length < 1) {
      message.warning('请勾选导出数据')
      return
    }
    await ORDER_EXPORT_ORDER_DETAIL({ ids: selectedRows })
  }

  const batchDownloadContractFile = async () => {
    const rawOrderPageState = String(
      searchParam?.orderPageState ??
        currentRadioDict[checkedRadioKey]?.numMap ??
        '',
    )
    const isOverdueTab = rawOrderPageState === ORDER_OVERDUE_TAB_NUM_MAP
    const resolvedOverdueType = resolveOrderListOverdueType(
      searchParam?.overdueType,
      isOverdueTab,
      searchParam != null &&
        typeof searchParam === 'object' &&
        'overdueType' in searchParam,
    )
    const params: ExportZipParams = {
      ids: selectedRows,
      ...searchParam,
      supplierId: getSupplierId(),
    }
    if (isOverdueTab) {
      params.orderPageState = ''
    }
    if (resolvedOverdueType !== undefined) {
      params.overdueType = resolvedOverdueType
    } else {
      delete params.overdueType
    }
    const res = await BATCH_DOWNLOAD_ZIP_THE_CONTRACT(params)
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    } else {
      message.warning(res.msg)
    }
  }

  // 跳转至客户回款明细页面
  const jumpToPaymentDetails = () => {
    history.push({
      pathname: '/srm/paymentDetails',
    })
  }

  return {
    state,
    getHasFilterBtn,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    handleTableChangeCheck,
    exportFile,
    batchDownloadContractFile,
    handleCheckParamChange,
    jumpToPaymentDetails,
  }
}
